import React from 'react'

const BarangayAbout = ({ barangay }) => {
  if (!barangay.about_us) return null

  // Function to detect if a line is part of a table
  const isTableLine = (line) => {
    return line.includes('|') || line.includes('---')
  }

  // Function to format the content with preserved tables and centered sections
  const formatContent = (text) => {
    const lines = text.split('\n')
    const elements = []
    let currentParagraph = []
    let currentTable = []
    let inTable = false
    let inCenter = false

    lines.forEach((line, index) => {
      const trimmedLine = line.trim()

      // Check for <center> tag
      if (trimmedLine === '<center>') {
        // Save any pending paragraph
        if (currentParagraph.length > 0) {
          elements.push({
            type: 'paragraph',
            content: currentParagraph.join('\n'),
            centered: false,
            key: `p-${elements.length}`
          })
          currentParagraph = []
        }
        inCenter = true
        return
      }

      // Check for </center> tag
      if (trimmedLine === '</center>') {
        if (currentParagraph.length > 0) {
          elements.push({
            type: 'paragraph',
            content: currentParagraph.join('\n'),
            centered: true,
            key: `p-${elements.length}`
          })
          currentParagraph = []
        }
        inCenter = false
        return
      }

      // Check if this is a table line
      if (isTableLine(line)) {
        // Save any pending paragraph
        if (currentParagraph.length > 0) {
          elements.push({
            type: 'paragraph',
            content: currentParagraph.join('\n'),
            centered: inCenter,
            key: `p-${elements.length}`
          })
          currentParagraph = []
        }

        currentTable.push(line)
        inTable = true
      } else if (inTable && trimmedLine === '') {
        // End of table
        if (currentTable.length > 0) {
          elements.push({
            type: 'table',
            content: currentTable.join('\n'),
            key: `t-${elements.length}`
          })
          currentTable = []
        }
        inTable = false
      } else if (inTable) {
        currentTable.push(line)
      } else {
        // Regular paragraph content
        if (trimmedLine === '') {
          if (currentParagraph.length > 0) {
            elements.push({
              type: 'paragraph',
              content: currentParagraph.join('\n'),
              centered: inCenter,
              key: `p-${elements.length}`
            })
            currentParagraph = []
          }
        } else {
          currentParagraph.push(line)
        }
      }
    })

    // Handle remaining content
    if (currentTable.length > 0) {
      elements.push({
        type: 'table',
        content: currentTable.join('\n'),
        key: `t-${elements.length}`
      })
    }
    if (currentParagraph.length > 0) {
      elements.push({
        type: 'paragraph',
        content: currentParagraph.join('\n'),
        centered: inCenter,
        key: `p-${elements.length}`
      })
    }

    return elements
  }

  const formattedContent = formatContent(barangay.about_us)

  return (
    <section className="section bg-white">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="section-head text-center">
              <h2 className="title title-s4">About {barangay.name}</h2>
            </div>
            <div className="nk-block">
              <div className="text-content">
                {formattedContent.map((element) => {
                  if (element.type === 'table') {
                    return (
                      <pre
                        key={element.key}
                        style={{
                          fontFamily: 'Courier New, monospace',
                          fontSize: '0.85rem',
                          lineHeight: '1.6',
                          backgroundColor: '#f8f9fa',
                          padding: '15px',
                          borderRadius: '4px',
                          overflowX: 'auto',
                          marginBottom: '20px',
                          border: '1px solid #dee2e6',
                          whiteSpace: 'pre'
                        }}
                      >
                        {element.content}
                      </pre>
                    )
                  } else {
                    return (
                      <p
                        key={element.key}
                        style={{
                          fontSize: element.centered ? '1.1rem' : '1.05rem',
                          lineHeight: '1.8',
                          textAlign: element.centered ? 'center' : 'justify',
                          marginBottom: '15px',
                          whiteSpace: 'pre-wrap',
                          fontWeight: element.centered ? '600' : 'normal'
                        }}
                      >
                        {element.content}
                      </p>
                    )
                  }
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default BarangayAbout
